'use client';

import {
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
  type Faro,
} from '@grafana/faro-react';
import packageJson from '../../package.json';

let faro: Faro | undefined;

export function initFaro(): Faro | undefined {
  if (typeof window === 'undefined') return;

  if (faro) return faro;

  const url = process.env.NEXT_PUBLIC_FARO_COLLECTOR_URL;

  const env = process.env.NEXT_PUBLIC_WEB_VITALS_ENV;

  if (!url || env === 'local') return;

  faro = initializeFaro({
    url,

    app: {
      name: 'revamped-cjr-web',
      version: packageJson.version || '0.0.0',
      environment: env,
    },

    instrumentations: [...getWebInstrumentations(), new ReactIntegration()],
  });

  return faro;
}
